import React, { useEffect, useState } from 'react'
import { useLocale } from "../i18n/localeContext";
import PropTypes from 'prop-types';

// Variable global para controlar si ya se está mostrando un error
let isErrorShowing = false;

export function StrapiError({ onRetry, onUseDefault }) {
    const { setLocale } = useLocale();
    const [shouldShow, setShouldShow] = useState(false);

    useEffect(() => {
        if (!isErrorShowing) {
            isErrorShowing = true;
            setShouldShow(true);
        } else {
            setShouldShow(false);
        }

        return () => {
            isErrorShowing = false;
        };
    }, []);

    if (!shouldShow) {
        return null;
    }

    const handleDefaultLanguage = () => {
        setLocale("es");
        // Llamar a la función onUseDefault para cargar valores por defecto
        onUseDefault();
    };

    return (
      <div style={{ 
        position: 'fixed', 
        top: 0, 
        left: 0, 
        width: '100vw', 
        height: '100vh', 
        zIndex: 9999,
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center', maxWidth: 520, padding: 24 }}>
          <h2>⚠️ Traducciones en inglés no disponibles</h2>
          <p>Hubo un problema al cargar las traducciones en inglés. Puede continuar con el idioma por defecto (español) o reintentar cargar las traducciones.</p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={onRetry}
              style={{
                padding: '10px 16px',
                borderRadius: 8,
                border: 'none',
                cursor: 'pointer',
                fontWeight: 600,
                backgroundColor: '#f0f0f0',
                color: '#333'
              }}
            >
              Reintentar
            </button>
            <button
              onClick={handleDefaultLanguage}
              style={{
                padding: '10px 16px',
                borderRadius: 8,
                border: 'none',
                cursor: 'pointer',
                fontWeight: 600,
                backgroundColor: '#035cc9',
                color: 'white'
              }}
            >
              Idioma por defecto
            </button>
          </div>
        </div>
      </div>
    );
}

StrapiError.propTypes = {
  onRetry: PropTypes.func.isRequired,
  onUseDefault: PropTypes.func.isRequired
};